<template>
  <div class="login">

    <div class="title-inner">
      <h2 class="">{{ projectName }}</h2>
      <p class="">{{ ProjectName_EN }}</p>
    </div>
    <div class="box">
      <div class="login_inner">
        <h5 class="center">欢迎登录</h5>
        <div class="item item1">
          <div class="icon icon-user"></div>
          <input type="text" v-model="LoginNo" placeholder="用户名" autocomplete="off" prop="LoginNo" data-mode="en" />
        </div>
        <div class="item item2">
          <div class="icon icon-password"></div>
          <input @keyup.enter="handleLogin" type="password" v-model="Password" prop="Password" data-mode="en"
                 placeholder="密码" maxlength="15" oncopy="return false" oncut="return false" onpaste="return false" />
        </div>
        <div class="handle_inner">
          <el-checkbox v-model="memory" class="mini">记住密码</el-checkbox>
        </div>
        <div class="item item3">
          <input type="text" v-model="code" placeholder="验证码" autocomplete="off" prop="code" data-mode="en" />
          <canvas id="canvas" @click="initCode" width="100" height="43"></canvas>
        </div>
        <button @click="handleLogin" class="btn_inner login_btn">
          登 录
        </button>
      </div>
    </div>

    <!--向上冒的方块-->
    <ul class="circles">
      <li>DYGPT</li>
      <li>工作流</li>
      <li>AI场景</li>
      <li>智能客服</li>
      <li>智能体</li>
      <li>投研助手</li>
      <li>训练</li>
      <li>流程</li>
      <li>知识库</li>
      <li>搭建</li>
    </ul>
  </div>
</template>

<script>
// import userManager from '@/utils/userManager'
import apiUser from "@/api/user";
export default {
  data () {
    return {
      projectName: window.ProjectTitle,
      ProjectName_EN: window.ProjectTitle_EN,
      LoginNo: '',
      Password: '',
      code: '',
      codeNum: [],
      memory: false
    }
  },
  watch: {
    memory (n) {
      if (!n) {
        localStorage.removeItem('loadingCondition')
      }
    }
  },
  created () {
    // 记录的账号密码
    // const loadingCondition = JSON.parse(localStorage.decode('loadingCondition') || null)

    // if (loadingCondition) {
    //   this.memory = true
    //   this.LoginNo = loadingCondition[0]
    //   this.Password = loadingCondition[1]
    // }

    // if (!this.LoginNo && !this.Password && process.env.NODE_ENV === 'development') {
    //   this.LoginNo = 'lhy100' // dy001-dy004
    //   this.Password = '1234'
    // }

    // 解析地址栏参数，实现自动登录
    this.parseUrlParams()

  },
  mounted () {
    // 清空所有会话存储
    sessionStorage.clear()
    this.initCode()
  },
  methods: {
    initCode () {
      this.codeNum.length = 0
      this.draw(this.codeNum)
    },

    generateRandomColor () {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = 'rgb(' + r + ',' + g + ',' + b + ')'
      return color
    },

    draw (showNum) {
      let target = document.querySelector('#canvas')
      let canvasWidth = target.clientWidth
      let canvasHeight = target.clientHeight
      let canvas = document.getElementById('canvas') // 获取到canvas的对象，演员
      let context = canvas.getContext('2d') // 获取到canvas画图的环境，演员表演的舞台
      canvas.width = canvasWidth
      canvas.height = canvasHeight
      let sCode = 'A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0'
      let aCode = sCode.split(',')
      let aLength = aCode.length // 获取到数组的长度

      for (let i = 0; i <= 3; i++) {
        let j = Math.floor(Math.random() * aLength) // 获取到随机的索引值
        let deg = Math.random() * 30 * Math.PI / 180 // 产生0~30之间的随机弧度
        let txt = aCode[j] // 得到随机的一个内容
        showNum[i] = txt.toLowerCase()
        let x = 10 + i * 20 // 文字在canvas上的x坐标
        let y = 20 + Math.random() * 8 // 文字在canvas上的y坐标
        context.font = 'bold 23px 微软雅黑'

        context.translate(x, y)
        context.rotate(deg)

        context.fillStyle = this.generateRandomColor()
        context.fillText(txt, 0, 0)

        context.rotate(-deg)
        context.translate(-x, -y)
      }
      for (let i = 0; i <= 5; i++) { // 验证码上显示线条
        context.strokeStyle = this.generateRandomColor()
        context.beginPath()
        context.moveTo(Math.random() * canvasWidth, Math.random() * canvasHeight)
        context.lineTo(Math.random() * canvasWidth, Math.random() * canvasHeight)
        context.stroke()
      }
      for (let i = 0; i <= 30; i++) { // 验证码上显示小点
        context.strokeStyle = this.generateRandomColor()
        context.beginPath()
        let x = Math.random() * canvasWidth
        let y = Math.random() * canvasHeight
        context.moveTo(x, y)
        context.lineTo(x + 1, y + 1)
        context.stroke()
      }
    },

    // 解析地址栏参数
    parseUrlParams () {
      const userNo = this.$route.query.userno
      const pwd = this.$route.query.pwd

      if (userNo && pwd) {
        this.LoginNo = userNo
        this.Password = pwd
        // 自动登录，跳过验证码
        this.handleLogin(true)
      }
    },

    // 登录
    handleLogin (skipCode = false) {
      // 跳过验证码验证
      if (!skipCode) {
        let code = this.codeNum.join('')
        if (this.code.toLowerCase() !== code) {
          this.$message.error('验证码有误')
          return
        }
      }
      if (this.LoginNo && this.Password) {
        let loading = this.$loading({
          lock: true,
          text: '登录中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        apiUser.Login({
          userName: this.LoginNo,
          password: this.Password
        }
        ).then((res) => {
          loading.close()
          sessionStorage.setItem("token", res.data.token);
          sessionStorage.setItem("userInfo", JSON.stringify(res.data.user));
          // sessionStorage.setItem('dygptaccount', '?u=' + this.LoginNo + '&p=' + this.Password)
          // 检查LoginNo的第一位是否为字母，如果是则转换为小写
          let processedLoginNo = this.LoginNo;
          if (processedLoginNo && processedLoginNo.length > 0) {
            const firstChar = processedLoginNo.charAt(0);
            // 使用正则表达式检查第一个字符是否为字母
            if (/[a-zA-Z]/.test(firstChar)) {
              // 转换第一个字符为小写，并与剩余部分拼接
              // processedLoginNo = firstChar.toLowerCase() + processedLoginNo.slice(1);
            }
          }
          sessionStorage.setItem('dygptaccount', processedLoginNo)
          // sessionStorage.setItem('dygptaccount', this.LoginNo)
          sessionStorage.setItem('dygptpwd', this.Password)
          sessionStorage.getItem('firstUse', 1)
          this.$router.push({
            path: '/main'
          })

          // 是否保存密码
          if (this.memory) {
            localStorage.encode('loadingCondition', JSON.stringify([this.LoginNo, this.Password]))
          }
        }).catch(err => {
          loading.close()
          if (err.data?.message) {
            this.$message.warning(err.data.message)
          }
        });

      } else {
        this.$message({
          type: 'warning',
          message: '请输入账号、密码'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  padding: 0 !important;
  position: relative;
  user-select: none;
  z-index: 2;
  margin: 0;
  overflow: hidden;
  // background: linear-gradient(135deg, #e6e6e6 0%, #569fdb 100%);
  // background: linear-gradient(135deg, #1a2d44 0%, #081420 100%);

  .wave-container {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  svg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200%;
    height: 100%;
    background: rgba(255, 255, 255, 0.1);
    animation: wave-animation 10s linear infinite;
  }

  .wave-1 {
    animation-duration: 10s;
    opacity: 0.8;
  }

  .wave-2 {
    animation-duration: 15s;
    opacity: 0.5;
  }

  .wave-3 {
    animation-duration: 20s;
    opacity: 0.3;
  }

  @keyframes wave-animation {
    0% {
      transform: translateX(0);
    }

    100% {
      transform: translateX(-50%);
    }
  }
}

.box {
  display: flex;
  justify-content: center;
}

//向上冒的方块开始
.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100%;
  height: calc(100% - 1.1rem);
  overflow: hidden;
  z-index: 1;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 200px;
  height: 20px;
  // background: rgba(47, 137, 254, 0.3);
  animation: animate 25s linear infinite;
  bottom: -150px;
  color: #fff;
  // font-size: 18px;
  text-shadow: 0 0 3px rgba(255, 255, 255, 0.7),
    0 0 6px rgba(255, 255, 255, 0.5),
    0 0 10px rgba(255, 255, 255, 0.3);
}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
  font-size: 16px;
}

.circles li:nth-child(2) {
  left: 10%;
  // width: 20px;
  // height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
  font-size: 18px;
}

.circles li:nth-child(3) {
  left: 70%;
  // width: 20px;
  // height: 20px;
  animation-delay: 4s;
  font-size: 16px;
}

.circles li:nth-child(4) {
  left: 40%;
  // width: 60px;
  // height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
  font-size: 18px;
}

.circles li:nth-child(5) {
  left: 65%;
  // width: 20px;
  // height: 20px;
  animation-delay: 0s;
  font-size: 16px;
}

.circles li:nth-child(6) {
  left: 75%;
  // width: 110px;
  // height: 110px;
  animation-delay: 3s;
  font-size: 18px;
}

.circles li:nth-child(7) {
  left: 35%;
  // width: 150px;
  // height: 150px;
  animation-delay: 7s;
  font-size: 16px;
}

.circles li:nth-child(8) {
  left: 50%;
  // width: 25px;
  // height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
  font-size: 18px;
}

.circles li:nth-child(9) {
  left: 20%;
  // width: 15px;
  // height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
  font-size: 16px;
}

.circles li:nth-child(10) {
  left: 85%;
  // width: 150px;
  // height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
  font-size: 18px;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }

  100% {
    // transform: translateY(-1000px) rotate(720deg);
    transform: translateY(-1000px) rotate(0deg);
    opacity: 0;
    border-radius: 50%;
  }
}

//向上冒的方块结束

.title-inner {
  // height: 1.1rem;
  height: 110px;
  width: 100%;
  background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 1rem;
  margin-top: 100px;

  h2 {
    // font-size: 0.70rem;
    // letter-spacing: 0.04rem;
    font-size: 70px;
    letter-spacing: 4px;
    font-weight: 500;
    text-shadow: 1px 0 0 #24479F;
    color: white;
    // text-shadow: 0px 0px 15px #006FFF, 0px 0px 15px #006FFF, 0px 0px 15px #006FFF;
    font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
  }

  p {
    // font-size: 0.3rem;
    // letter-spacing: 0.05rem;
    // margin-top: 0.15rem;
    font-size: 30px;
    letter-spacing: 5px;
    margin-top: 15px;
    // color: #A2C5F1;
    color: white;
    text-shadow: 0px 0px 15px #A2C5F1, 0px 0px 15px #A2C5F1, 0px 0px 15px #A2C5F1;
  }
}

//登录框渐显动画
@keyframes showlogin_inner {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

// 登录框
.login_inner {
  z-index: 99;
  position: relative;
  top: 10%;
  border-radius: 5px 5px 5px 5px;
  background-size: 100% 100%;
  // width: 4.6rem;
  // height: 5rem;
  width: 460px;
  height: 500px;
  box-sizing: border-box;
  // padding: 0.22rem 0.6rem;
  padding: 22px 60px;
  // margin-bottom: 0.3rem;
  backdrop-filter: blur(20px);
  box-shadow: 0 0 30px 10px rgba(0, 0, 0, .1);
  opacity: 0;
  animation: showlogin_inner 1.8s ease-in-out forwards;
  // margin: 0.5rem 1rem 0 1rem;
  margin: 50px 100px 0 100px;

  h5 {
    // font-size: 0.22rem;
    font-size: 22px;
    // color: #333;
    color: #fff;
    // margin: .4rem 0 0.3rem 0;
    margin: 40px 0 30px 0;
    letter-spacing: 2px;
    text-align: center;
    font-weight: bold;
  }

  // 登录项
  .item,
  .item input,
  button {
    width: 100%;
  }

  .item {
    display: flex;
    align-items: center;
    overflow: hidden;
    border-radius: 5px;
    // height: 0.42rem;
    // margin-top: 0.2rem;
    height: 42px;
    margin-top: 20px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #DEDEDE;
  }

  .icon {
    // margin-left: 0.22rem;
    // width: 0.28rem;
    // height: 0.28rem;
    margin-left: 22px;
    width: 28px;
    height: 28px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.8;

    &.icon-user {
      background-image: url('~@imgs/login/icon_account.png');
    }

    &.icon-password {
      background-image: url('~@imgs/login/icon_psw.png');
    }
  }

  .item input {
    display: block;
    height: 100%;
    border: 0;
    // font-size: 0.16rem;
    // padding: 0 0.18rem;
    font-size: 16px;
    padding: 0 18px;
    outline: none;
    color: #333;
    letter-spacing: 1px;

    &:-webkit-autofill {
      transition: background-color 50000s ease-in-out 0s;
    }

    &::-moz-placeholder {
      color: #b6b6b6;
    }

    &:-ms-input-placeholder {
      color: #b6b6b6;
    }

    &::-webkit-input-placeholder {
      color: #b6b6b6;
    }
  }

  .handle_inner {
    // margin-top: 0.15rem;
    margin-top: 15px;
  }

  // 登录按钮
  .login_btn {
    // height: 0.4rem;
    // margin-top: 0.3rem;
    height: 40px;
    margin-top: 30px;
    background-color: #1095ee;
    // margin-bottom: 0.52rem;
    margin-bottom: 52px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    // gap: 1rem;
    gap: 100px;
    font-size: 1.125em;
    font-weight: 800;
    letter-spacing: 2px;
    color: #fff;
    background: #1095ee;
    border: 2px solid #1095ee;
    // border-radius: 0.75rem;
    border-radius: 75px;
    box-shadow: 0 8px 0 #65a9d6;
    transform: skew(-10deg);
    transition: all 0.1s ease;
    filter: drop-shadow(0 15px 20px #1095ee);

    &:active {
      letter-spacing: 0px;
      transform: skew(-10deg) translateY(8px);
      box-shadow: 0 0 0 #1095ee;
    }
  }

}
</style>
